import { IDataTypeData, IDrawer } from "../../PublicationContent";
import { dataTypeArticleContentModifier } from "./Article";
import { dataTypeClientContentModifier } from "./Client";
import { dataTypeCommunityContentModifier } from "./Community";
import { dataTypeMemberCompanyContentModifier } from "./Company";
import { dataTypeConveningContentModifier } from "./Convening";
import { dataTypeIndustryContentModifier } from "./Industry";
import { dataTypePassionContentModifier } from "./Passion";
import { dataTypePersonContentModifier } from "./Person";
import { dataTypeProjectContentModifier } from "./Project";
import { dataTypeResourceContentModifier } from "./Resource";
import { dataTypeSkillContentModifier } from "./Skill";
import { dataTypeToolContentModifier } from "./Tools";

interface dataTypeContentModifierParams {
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>;
  push: (location: any, state?: any) => void;
  node: HTMLDivElement;
  setDataTypeData: React.Dispatch<React.SetStateAction<IDataTypeData>>;
  openResourceModal: (slug: string) => void;
}

export const dataTypeContentModifier = ({node, setDrawer, push, setDataTypeData, openResourceModal}: dataTypeContentModifierParams) => {
  dataTypePersonContentModifier(node, setDrawer);
  dataTypePassionContentModifier(node, setDrawer);
  dataTypeSkillContentModifier(node, setDrawer);
  dataTypeClientContentModifier(node, setDrawer);
  dataTypeProjectContentModifier(node, setDrawer);
  dataTypeMemberCompanyContentModifier(node, setDrawer);
  dataTypeIndustryContentModifier(node, setDrawer);
  dataTypeResourceContentModifier(node, push, openResourceModal);
  dataTypeCommunityContentModifier(node, push, setDataTypeData);
  dataTypeConveningContentModifier(node, push, setDataTypeData);
  dataTypeArticleContentModifier(node, push, setDataTypeData);
  dataTypeToolContentModifier(node, push, setDataTypeData);
};